module.exports = __webpack_public_path__ + "assets/img/btn-download-hover-5373005b.png";